import { makeStyles } from '@material-ui/core/styles';
import { colorMap, ColorNames, TextColors } from '@/utils/constants';

const useAccountNavigationItemStyles = makeStyles((muiTheme) => ({
  root: {
    color: `${TextColors.light} !important`,
    '&:hover, &.account-navigation-selected': {
      color: '#ffffff !important',
      '& .hover-element': {
        opacity: 0.7,
      },
      '& .account-navigation-icon': {
        visibility: 'visible',
      },
    },
    fontSize: '14px',
    lineHeight: '18px',
    '& > .account-navigation-item-content': {
      zIndex: 1,
      display: 'flex',
      alignItems: 'center',
    },
    '& .hover-element': {
      position: 'absolute',
      backgroundColor: colorMap[ColorNames.mediumGray],
      top: muiTheme.spacing(-0.9),
      left: muiTheme.spacing(-1.5),
      right: muiTheme.spacing(-1.5),
      bottom: muiTheme.spacing(-0.9),
      opacity: 0,
      borderRadius: '4px',
      transition: 'opacity 150ms ease-in-out 0s',
    },
    '& .account-navigation-icon > path': {
      stroke: '#ffffff',
    },
    '& .account-navigation-icon': {
      visibility: 'hidden',
    },
  },
  label: {
    display: 'inline-block',
    marginRight: muiTheme.spacing(1),
  },
}));

export default useAccountNavigationItemStyles;
